/**
 * First-paint fallback content. This is a deliberate mirror of the backend
 * `seed.js` + `config/company.js` so the landing page renders fully even when
 * the API is unreachable. When the API responds, live data replaces these.
 *
 * Keep this in sync with the backend seed if the seed changes.
 */

export const company = {
  name: 'Thunder Technologies',
  tagline: 'Security, connectivity & smart digital tools',
  about:
    'Thunder Technologies delivers CCTV and Wi-Fi installations for offices and ' +
    'businesses, and is building a subscription-based ecosystem of digital tools ' +
    '(SEO auditing, network scanning and more).',
  director: 'Ernest Kaburi Mwangi',
  contact: {
    phone: '+254 713 522 833',
    email: 'info@thundertechnologies.co.ke',
    country: 'Kenya',
    currency: 'KES',
  },
  hours: 'Mon–Fri, 9:00 AM – 5:00 PM',
  warranty: '2-year warranty on CCTV, NVR and Wi-Fi hardware (extended support available).',
};

export const services = [
  {
    slug: 'cctv-installation',
    title: 'CCTV Installation',
    category: 'cctv',
    summary:
      'High-resolution Hikvision IP CCTV with NVR recording and secure remote access.',
    features: [
      'Hikvision IP cameras (indoor/outdoor)',
      'NVR with high-capacity storage',
      'UPS backup power integration',
      'Secure remote access setup',
      '2-year hardware warranty',
    ],
    priceFrom: 45000,
    order: 1,
  },
  {
    slug: 'wifi-installation',
    title: 'Wi-Fi Installation',
    category: 'wifi',
    summary:
      'Commercial-grade Wi-Fi with full-coverage design and guest/staff segmentation.',
    features: [
      'Commercial-grade access points',
      'Full-coverage site design',
      'Guest & staff network segmentation',
      'Performance testing & tuning',
    ],
    priceFrom: 25000,
    order: 2,
  },
  {
    slug: 'networking-structured-cabling',
    title: 'Networking & Structured Cabling',
    category: 'networking',
    summary: 'Routers, switches and structured cabling for reliable business networks.',
    features: ['MikroTik/enterprise routers', 'Managed switches', 'Structured cabling', 'VLANs'],
    priceFrom: 15000,
    order: 3,
  },
  {
    slug: 'seo-audit',
    title: 'SEO Audit Tool',
    category: 'digital-tool',
    summary:
      'On-demand website SEO audits — meta tags, headings, performance signals and more.',
    features: ['On-page SEO checks', 'Meta & heading analysis', 'Actionable report'],
    order: 4,
  },
  {
    slug: 'network-scanner',
    title: 'Network Scanner Tool',
    category: 'digital-tool',
    summary: 'Scan your own hosts for open ports and availability, with safeguards.',
    features: ['Port & availability checks', 'Owned-target verification', 'Audit-logged'],
    order: 5,
  },
];

export const portfolio = [
  {
    slug: 'restaurant-cctv-wifi',
    title: 'Restaurant CCTV & Wi-Fi Deployment',
    client: 'Restaurant (confidential)',
    category: 'cctv',
    summary:
      'Comprehensive 16-camera Hikvision CCTV system plus commercial Wi-Fi across all zones.',
    location: 'Kenya',
    highlights: [
      '16 Hikvision IP cameras',
      '16-port NVR + 10TB storage',
      'Full-coverage commercial Wi-Fi',
      'UPS backup & remote access',
    ],
    featured: true,
    order: 1,
  },
  {
    slug: 'aqua-tools-office-cctv',
    title: 'Aqua Tools Office CCTV Surveillance',
    client: 'Aqua Tools',
    category: 'cctv',
    summary:
      'IP-based CCTV surveillance covering entrances, workstations, stores and perimeter.',
    location: 'Kenya',
    highlights: [
      'Entrance/exit & perimeter coverage',
      'Centralized NVR management',
      'Secure remote viewing',
    ],
    featured: true,
    order: 2,
  },
];
